import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowCircleLeft} from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft';
import {withRouter} from 'react-router-dom';

import {Button} from 'Components/Partials/Form';

class BackButton extends React.Component {
    /**
     * @method handleGoBack
     */
    handleGoBack = () => {
        this.props.history.goBack();
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        return (
            <Button onClick={this.handleGoBack} className={'w-full md:w-auto'}>
                <FontAwesomeIcon icon={faArrowCircleLeft}/> Back
            </Button>
        );
    };
}

export default withRouter(BackButton);
